/* eslint-disable @angular-eslint/component-selector */
import { Component, HostListener } from '@angular/core';
import { sideBar } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { AuthService } from '../../services/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LoginResponse } from '../../core/constants/loginResponse.model';

@Component({
  selector: 'tusangaire-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  assetsConst = assets;
  public sideBar = sideBar;
  public innerWidth = 0;
  public sidenavWidth = 5;
  protected subscriptionSubject$: Subscription;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(public _authService: AuthService) {
    this.subscriptionSubject$ = this._authService.profileDetails
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: LoginResponse | null) => {
        if (res !== null) {
          this.sideBarHandler(res);
        }
      });
  }

  sideBarHandler(res: LoginResponse): void {
    const allowedRoles = res.role || [];
    const restrictedModules: Record<number, string> = {
      1: 'Manage Package',
      2: 'Manage Homestay',
      3: 'Manage Ticketing'
    };

    this.sideBar = this.sideBar.filter((item) => {
      if (item.text === 'Manage Experience' && item.subMenuItems) {
        item.subMenuItems = item.subMenuItems.filter((subItem) => !Object.keys(restrictedModules).some((roleKey) => {
          const roleKeyNumber = Number(roleKey);
          return (
            !allowedRoles.includes(roleKeyNumber) &&
              restrictedModules[roleKeyNumber] === subItem.text
          );
        })
        );
        return item.subMenuItems.length > 0;
      }

      // General case: filter the main sidebar items
      return !Object.keys(restrictedModules).some((roleKey) => {
        const roleKeyNumber = Number(roleKey);
        return (
          !allowedRoles.includes(roleKeyNumber) &&
          restrictedModules[roleKeyNumber] === item.text
        );
      });
    });

  }

  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 991) {
      this._authService.toggleSidebarView();
    }
  }
}
